// extracted by mini-css-extract-plugin
export var accordion = "_da-0";
export var chevron = "_da-3";
export var closed = "_da-2";
export var content = "_da-4";
export var open = "_da-1";
export var rotate = "_da-5";